import BlurLinearIcon from "@material-ui/icons/BlurLinear";
import TrustPartList from "./TrustPartList";

export default {
  icon: BlurLinearIcon,
  list: TrustPartList,
};
